import { Box } from "@mui/material";
import React from "react";
import Icon from "../../../common/Icon/Icon";
import { PatientDetailText } from "./PatientGroupChatListItem.style";

export const PatientDetail = ({
  title,
  icon,
  text,
}: {
  title: string;
  icon: React.ReactElement;
  text: string;
}) => {
  let fullTitle = title.split(" ");
  let firstHalf = fullTitle[0];
  let lastHalf = fullTitle[1];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyItems: "center",
        marginBottom: "6px"
      }}>
      <Icon
        icon={icon}
        sx={{
          fontSize: "16px",
        }}
      />
      <PatientDetailText
        data-testid={`${firstHalf.toLowerCase()}-${lastHalf.toLowerCase()}`}
      >
        <span title={text}>{text}</span>
      </PatientDetailText>
    </Box>
  );
};
